"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/People/ChangeRoleModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Avatar = require('web/components/Avatar');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _RadioInput = require('web/components/Form/RadioInput');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _noticeBar = require('web/services/context/noticeBar');
var _people = require('./people');

// One choice (F-12): no account role, IT or Owner, each with what it means.
const CHOICES = [
  { role: null, label: 'None', hint: 'No account role. What they can do comes from their role in each organization.' },
  { role: 'it', label: _useOrgAccount.ACCOUNT_ROLE_LABELS.it, hint: _useOrgAccount.ACCOUNT_ROLE_HINTS.it },
  { role: 'owner', label: _useOrgAccount.ACCOUNT_ROLE_LABELS.owner, hint: _useOrgAccount.ACCOUNT_ROLE_HINTS.owner },
]

const buttonLabel = (role) => role ? `Make ${_useOrgAccount.ACCOUNT_ROLE_LABELS[role]}` : 'Remove role'








/* Change account role (screen 05): None, IT or Owner, one choice. Owners may
 * choose any; IT may choose IT or None, and can't change an Owner (D-38).
 * The server refuses removing the last Owner. */
const ChangeRoleModal = ({ orgKey, person, myRole, onClose }) => {
  const current = person.AccountRole || null
  const [role, setRole] = _react.useState(current)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const grantable = _useOrgAccount.grantableAccountRoles.call(void 0, myRole)
  // Only an Owner changes an Owner.
  const canChange = current !== 'owner' || myRole === 'owner'
  const name = _people.personName.call(void 0, person)

  const save = () => {
    setIsSaving(true)
    const request = role
      ? _actions2.default.grantAccountRole({ OrgKey: orgKey, UserKey: person.UserKey, Role: role })
      : _actions2.default.revokeAccountRole({ OrgKey: orgKey, UserKey: person.UserKey })
    request
      .then(() => {
        showSuccessBar(role ? `${name} is now ${_useOrgAccount.ACCOUNT_ROLE_LABELS[role]}` : `${name} no longer has an account role`)
        onClose()
      })
      .catch(() => {
        showWarningBar('Couldn\'t change the account role')
        setIsSaving(false)
      })
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, onClose: onClose, title: "Change account role"  , className: "account-role-modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
      , _react2.default.createElement('div', { className: "account-role-modal--person", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
        , _react2.default.createElement(_Avatar.UserAvatar, { userKey: person.UserKey, size: 44, noOnlineIndicator: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}} )
        , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          , _react2.default.createElement('div', { className: "account-role-modal--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  name )
          , _react2.default.createElement('div', { className: "account-role-modal--email", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}},  person.Email )
        )
      )
      , _react2.default.createElement('div', { className: "account-role-modal--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Account role" )
      , _react2.default.createElement('div', { role: "radiogroup", 'aria-label': "Account role" , className: "account-role-modal--choices", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
        ,  CHOICES.map(c => {
          const isDisabled = !canChange || (c.role !== null && !grantable.includes(c.role))
          return (
            _react2.default.createElement(_RadioInput.RadioOption, {
              key: _nullishCoalesce(c.role, () => ( 'none')),
              selected: role === c.role,
              disabled: isDisabled,
              onClick: () => { if (!isDisabled) setRole(c.role) },
              className: "account-role-modal--choice",
              label: (
                _react2.default.createElement(_react2.default.Fragment, null
                  , _react2.default.createElement('span', { className: "account-role-modal--choice-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}},  c.label )
                  , _react2.default.createElement('span', { className: "account-role-modal--choice-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}},  c.hint )
                )
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
            )
          )
        })
      )
      ,  role && role !== current && (
        _react2.default.createElement(_WarningBar2.default, { className: "blm-toggle--warning account-role-modal--warning" , iconSrc: "/assets/icons/alert-orange.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
          ,  _useOrgAccount.ACCOUNT_ROLE_WARNING 
        )
      )
      ,  !canChange && _react2.default.createElement('p', { className: "account-role-modal--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "Only Owners can change an Owner's role."      ) 
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: buttonLabel(role),
        isPrimaryEnabled: canChange && role !== current && !isSaving,
        isPrimaryLoading: isSaving,
        onPrimaryBtnClick: save,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
      )
    )
  )
}

exports. default = ChangeRoleModal
